import { render, staticRenderFns } from "./BankDetailsBulkUpload.vue?vue&type=template&id=d6055004&scoped=true"
import script from "./BankDetailsBulkUpload.vue?vue&type=script&lang=js"
export * from "./BankDetailsBulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6055004",
  null
  
)

export default component.exports